import { CompleteProfileService } from './../../services/account/complete-profile.service';
import { MessageService } from 'primeng/api';
import { RecommendationService } from './../../services/recommendation/recommendation.service';
import { EssayPilotService } from './../../services/essay-pilot/essay-pilot.service';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { ButtonModule } from 'primeng/button';
import { DropdownChangeEvent, DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';
import { CheckboxModule } from 'primeng/checkbox';
import { Store } from '@ngxs/store';
import { MyInstitutesSelectors } from '../../states/myInstitutes/my-institute-selector';
import { Institute, PageResponse } from '../../models/institute/randomInstituteResponse';
import { CommonModule } from '@angular/common';
import { pilotType } from '../../models/essay-pilot/essayQuestionRequest';
import { EssayEditorComponent } from "./essay-editor/essay-editor.component";
import { InstituteEssayEditorComponent } from "./institute-essay-editor/institute-essay-editor.component";
import { EssayAnswerResponse } from '../../models/essay-pilot/essayAnswerResponse';
import { catchError, concatMap, filter, finalize, forkJoin, map, of, switchMap, tap } from 'rxjs';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { ContentEditorComponent, EditorContent } from '../../utility/content-editor/content-editor.component';
import { FormsModule } from '@angular/forms';
import { ActivityEditorComponent } from "./activity-editor/activity-editor.component";
import { UserSelectors } from '../../states/user/user-selector';
import { UserStateModel } from '../../states/user/user-state-model';
import { AdditionalInformation } from '../../models/enums/additionalInformation';
import { AdditionalInformationComponent } from "../additional-information/additional-information.component";
import { ActivityDetails } from '../../models/account/extra-curricular/extraCurricularRequest';
import { CourseLevelEnum } from '../../models/enums/courseLevelEnum';
export interface essayOptions {
  title: string,
  name: string,
  wordlimit?: number,
}

export interface activityOptions {
  title: string,
  value: string
}

enum selectedTab {
  essaypilot,
  additionalInfo
}


@Component({
  selector: 'app-essay-pilot',
  standalone: true,
  imports: [AutoCompleteModule, InputTextareaModule, ButtonModule, DropdownModule, InputTextModule, CheckboxModule, FormsModule,
    CommonModule, EssayEditorComponent, InstituteEssayEditorComponent, ProgressSpinnerModule, ContentEditorComponent, ActivityEditorComponent, AdditionalInformationComponent],
  templateUrl: './essay-pilot.component.html',
  styleUrl: './essay-pilot.component.scss'
})

export class EssayPilotComponent implements OnInit {
  pilotType = pilotType;
  currentPilotType: pilotType = pilotType.common;
  myInstitutes: Institute[] = [];
  essays: EssayAnswerResponse[] = [];
  commonEssays: essayOptions[] = [];
  isLoading: boolean = false;
  instuteId: string | undefined;
  user: UserStateModel | undefined;
  questionsWordsLimits: number[] = [];
  applyingForLevel!: CourseLevelEnum;
  applyingForCourseName: string = '';

  //pastSubmissions

  //Recommendation
  initialContent: string = '';
  recommText: string = '';
  recommHtml: string = '';
  isRecommendLoading: boolean = false;
  isRecommSubmitted: boolean = false;
  //Recommendation

  //AdditionalInfo
  additionalInfoType = AdditionalInformation
  selectedTab = selectedTab;
  currentSelectedTab = selectedTab.essaypilot;

  extracurricularActivities!: activityOptions[];

  constructor(private store: Store,
    private recommendationService: RecommendationService,
    private essayPilotService: EssayPilotService,
    private messageService: MessageService,
    private cdr: ChangeDetectorRef,
    private completeProfileService: CompleteProfileService
  ) {
    this.getMyInstitutesFromState();
  }
  ngOnInit(): void {
    
    this.loadExtraCurricularActivities();
    this.loadCommonEssay();
  }

  getMyInstitutesFromState() {
    this.store.select(MyInstitutesSelectors.getMyInstitute).subscribe(
      {
        next: (response) => {
          if (response) {
            this.myInstitutes = response.items
          }
        }
      }
    );
  }

  openAdditionalInfo() {
    this.currentSelectedTab = selectedTab.additionalInfo;
  }

  loadInstituteEssays(instituteId: string) {
    //set Section to essayPilot
    this.currentSelectedTab = selectedTab.essaypilot;
    //ended
    this.instuteId = instituteId;
    this.isLoading = true;
    this.essays = [];
    this.essayPilotService.getInstituteQuestions({
      instituteId:instituteId,
      courseLevel: this.applyingForLevel,
      courseName: this.applyingForCourseName
    }).subscribe({
      next: (response) => {
        if (!response) {
          this.isLoading = false;
          this.currentPilotType = pilotType.specific; // After all requests complete
        }
        if (response) {
          const questions = [
            response.question1,
            response.question2,
            response.question3,
            response.question4,
            response.question5,
          ].filter(Boolean); // Filter out any undefined or null questions.
          this.questionsWordsLimits = [
            response.question1WordLimit,
            response.question2WordLimit,
            response.question3WordLimit,
            response.question4WordLimit,
            response.question5WordLimit,
          ].filter((x): x is number => typeof x === 'number');
          // Sequentially process questions
          of(...questions)
            .pipe(
              concatMap((question) =>
                this.essayPilotService
                  .getStudentEssayAnswer({ question: question ?? '', instituteId: this.instuteId })
                  .pipe(
                    map((result) =>
                      result ? result : { question } // If no result, add default question.
                    ),
                    catchError((error) => {
                      // Return a default value with the question.
                      return of({ question });
                    })
                  )
              ),
              finalize(() => {
                this.isLoading = false;
                this.currentPilotType = pilotType.specific; // After all requests complete
              })
            )
            .subscribe({
              next: (essay) => {
                this.essays.push(essay); // Push each essay sequentially
              },
            });
        }
      },
      error: (error) => {
        this.isLoading = false;
        console.warn(`Error while loading institute questions: ${error}`);
      },
    });
  }

  loadRecommendations() {
    //set Section to essayPilot
    this.currentSelectedTab = selectedTab.essaypilot;
    //ended
    this.isLoading = true;
    this.recommendationService.getRecommendation()
      .subscribe({
        next: (response) => {
          if (response) {
            this.initialContent = response.recommendationDetailsHtml ?? '';
            this.recommText = response.recommendationDetails ?? '';
            this.recommHtml = response.recommendationDetailsHtml ?? '';
            this.cdr.detectChanges(); // Ensures bindings update
            this.resetEditorsContent(this.initialContent);
          }
          this.currentPilotType = pilotType.recommendation;
          this.isLoading = false;
        },
        error: (error) => {
          console.warn(`Error while loading common questions: ${error}`);
          this.currentPilotType = pilotType.recommendation;
          this.isLoading = false;
        }
      });
  }

  resetEditorsContent(content: string) {
    const editor = document.querySelector('.ql-editor');
    if (editor) {
      // Overwrite the inner HTML of the editor
      editor.innerHTML = content;
    }
  }

  loadActivities() {
    //set Section to essayPilot
    this.currentSelectedTab = selectedTab.essaypilot;
    //ended
    this.currentPilotType = pilotType.activities;
  }
  loadCommonEssay() {
    //set Section to essayPilot
    this.currentSelectedTab = selectedTab.essaypilot;
    //reset recommned text
    this.initialContent = '';
    this.resetEditorsContent(this.initialContent);
    //ended
    this.isLoading = true;
    this.commonEssays = [];
    this.essayPilotService.getCommonEssayQuestions().subscribe({
      next: (response) => {
        const newEssays = response.result.map(essay => ({
          title: essay.question ?? '',  // Fallback to empty string if question is null
          name: essay.question ?? '',
          wordlimit: essay.answerWordLimit   // Fallback to empty string if question is null
        }));
        this.commonEssays = newEssays;
        this.isLoading = false;
        this.currentPilotType = pilotType.common;
      },
      error: (error) => {
        this.isLoading = false;
        console.warn(`Error while loading common questions: ${error}`);
      }
    });
  }


  allActivityDetails: PageResponse<ActivityDetails> | undefined;
  loadExtraCurricularActivities() {
    //set Section to essayPilot
    this.currentSelectedTab = selectedTab.essaypilot;
    //ended
    this.store.select(UserSelectors.getUser).pipe(
      filter(user => !!user?.id), // Ensure user exists before proceeding
      tap(user => (this.user = user)), // Store user
      switchMap(user =>
        forkJoin({
          activities: this.completeProfileService.getActivities(),
          extraCurricular: this.completeProfileService.getExtraCurricular(user.id),
          demography: this.completeProfileService.getDemography(user.id)
        })
      ),
      map(({ activities, extraCurricular, demography }) => {
        this.applyingForLevel = demography.degreePreference;
        this.applyingForCourseName = demography?.intendedMajor ?? '';
        this.allActivityDetails = extraCurricular;
        this.extracurricularActivities = extraCurricular.result.map(extraActivity => {
          const activity = activities.result.find(record => record.id === extraActivity.activityId);
          return {
            title: `${activity?.name || ''}-${extraActivity.organisationName || ''}-${extraActivity.participationGradeLevels || ''} Grade`,
            value: extraActivity.id || ''
          };
        });

        // this.currentPilotType = pilotType.activities;
      })
    ).subscribe({
      error: (error) => {
        console.warn(`Error while loading extracurricular activities: ${error}`);
      },
      complete: () => {
        this.isLoading = false;
      }
    });
  }


  get wordCount(): number {
    return this.recommText
      ? this.recommText.trim().split(/\s+/).filter((word) => word).length
      : 0;
  }

  onRecommendationChange($event: EditorContent) {
    this.recommText = $event.textValue;
    this.recommHtml = $event.htmlValue;
    this.cdr.detectChanges(); // Ensures bindings update
  }

  onRecommendationSubmit() {
    this.isRecommSubmitted = true;
    this.isRecommendLoading = true;
    if (this.recommText.length == 0) {
      return;
    }
    // if (this.wordCount > 650) {
    //   this.messageService.add({ severity: 'error', summary: 'Invalid', detail: `Words can't exceed 650 limit` });
    //   return;
    // }
    this.recommendationService.addRecommendation({
      recommendationDetails: this.recommText,
      recommendationDetailsHtml: this.recommHtml
    }).subscribe({
      next: (response) => {
        this.isRecommendLoading = false;
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: `Letter of Recoomendation is saved!`,
        });
      },
      error: (error) => {
        this.isRecommendLoading = false;
        console.warn(`Error while updating: ${error}`);
      }
    });
  }
}
